import type { IconProps } from './types';

export function Cropped({ size = 24, ...props }: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 256 256"
      fill="none"
      stroke="currentColor"
      strokeWidth="14"
      strokeLinejoin="round"
      strokeLinecap="round"
      {...props}
    >
      <path d="M76 80 Q88 76 100 80 Q128 104 156 80 Q168 76 180 80 Q204 92 228 120 Q220 128 208 124 Q198 116 188 108 L188 160 Q188 168 180 168 L76 168 Q68 168 68 160 L68 108 Q58 116 48 124 Q36 128 28 120 Q52 92 76 80 Z" />
    </svg>
  );
}
